import * as React from 'react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import type { FieldType } from 'modules/reports/components/Editor/Field/types'

interface Props {
  forms: ArgumentForm[]
  fieldType: FieldType
}

const EnumsSelector = ({ forms, fieldType }: Props) => {
  const { field } = fieldType

  if (!field) return null

  const options = field.attributes.enum_options
  const form = forms[0]

  return (
    form && (
      <FormRow>
        <Select
          none={i18n.t('custom_reports.fields.filter_none')}
          label={field.attributes.label}
          field={form.get('value')}
          options={options}
        />
      </FormRow>
    )
  )
}

export default EnumsSelector
